export default "__VITE_ASSET__CSQ$yFIk__"